// LIBRERIE/IMPORTS
import React from "react";
import { Helmet } from 'react-helmet';
import { useTranslation } from "react-i18next";

// HOOKS
import { useGetAgencyDetails } from "../../hooks/useGetAgencyDetails";

// CONFIGURAZIONI
import { AGENCY_ID, appConfig } from "../../config/appConfig";

// COMPONENTI
import SubHeaderHome from "../Header/subHeader/SubHeaderHome";
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";
import SubHeaderImmobili from "../Header/subHeader/SubHeaderImmobili";
import BannerVendi from "./BannerVendi";
import PropertySearchField from "./Search";
import ServicesSection from "./ServicesSection";
import ServicesSection2 from "./ServicesSection2";
import Vetrina2 from "./Vetrina2";
import FooterBannerVendi from "./FooterBannerVendi";
import LocationSearch from "./LocationSearch";

interface Props {
  seo: boolean;
  vetrina2: boolean;
  pageType: string;
  filters: { [key: string]: string[] };
  showServices: boolean;
  showServices2:boolean;
  showLocationSearch: boolean;
  showFooterBannerVendi: boolean;
  showPriceSlider: boolean;
}

const HomePage: React.FC<Props> = ({
  seo,
  vetrina2,
  pageType,
  filters,
  showServices,
  showServices2,
  showLocationSearch,
  showFooterBannerVendi,
  showPriceSlider
}) => {

  const { t, ready } = useTranslation();
  const { agency } = useGetAgencyDetails(AGENCY_ID);

  // --- Lettura Flag Indipendenti dalla Configurazione ---
  const shouldShowInSubHeader = appConfig.ui.searchForm.showSearchInHomePageSubHeader;
  const shouldShowBelowIntro = appConfig.ui.searchForm.showSearchBelowHomePageIntro;
  const shouldShowSearchAndFiltersSection = appConfig.ui.homePage.showSearchAndFilters;
  const shouldShowServices = appConfig.ui.homePage.showServices;
  const shouldShowServices2 = appConfig.ui.homePage.showServices2;
  const shouldShowLocationSearch = appConfig.ui.homePage.showLocationSearch;
  const shouldShowPriceSlider = appConfig.ui.searchForm.showPriceSlider;
  const isCarouselSubHeaderHome = appConfig.ui.homePage.isCarouselSubHeaderHome;
  const isBackgroundFixedSubHeaderHome = appConfig.ui.homePage.isBackgroundFixedSubHeaderHome;
  // const shouldShowPriceSlider = appConfig.ui.searchForm.showPriceSlider;
  
  // --- Fine Lettura ---

  const isSeo = pageType === 'home';

  if (!ready) return null;

  return (
    <>
      <Helmet>
        <title>{agency?.agencyName ?? t('common.loading')}</title>
      </Helmet>

      {/* === Rendering Condizionale Sub Headers === */}
      {pageType === "home" && (
        <SubHeaderHome
          isSeo={isSeo}
          showSearchForm={shouldShowInSubHeader}
          isCarousel={isCarouselSubHeaderHome}
          isBackgroundFixed={isBackgroundFixedSubHeaderHome}
          showPriceSlider={shouldShowPriceSlider}
        />
      )}
      {pageType === "immobili" && (
        <SubHeaderImmobili
          bodyTitle={t('propertyList.pageTitle')}
          filters={filters}
        />
      )}
      {pageType === "default" && (
        <SubHeaderDefault
          title={t('homePage.subHeaderDefaultTitle')}
          isSeo={isSeo}
        />
      )}

      {shouldShowSearchAndFiltersSection && pageType === 'home' &&
        <section className="space-ptb bg-green position-relative">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="text-center mb-4">
                  <h3 className="asH2SubTitle text-white">{t('homePage.searchFilterSection.title')}</h3>
                  <p>{t('homePage.searchFilterSection.paragraph')}</p>
                </div>
              </div>
            </div>
            {shouldShowBelowIntro && <PropertySearchField searchData={{}} showPriceSlider={showPriceSlider}/>}
          </div>
        </section>}

      {/* Vetrina con immobili */}
      {/* vetrina1 && <Vetrina1 /> */}

      {/* Vetrina con immobili */}
      {vetrina2 && <Vetrina2 agencyName={agency?.agencyName ?? ''} />}

      {/* Banner con bottone */}
      <BannerVendi agencyName={agency?.agencyName ?? ''} />

      {/* Ricerca veloce con immagini */}
      {shouldShowLocationSearch &&
        <LocationSearch seo={seo} showLocationSearch={showLocationSearch} />
      }
      
      {/*Sezione sevizi tipo 1*/}
      {shouldShowServices &&
        <ServicesSection agencyName={agency?.agencyName ?? ''} showServices={showServices} />
      }

      {/*Sezione sevizi tipo 2*/}
      {shouldShowServices2 &&
        <ServicesSection2 agencyName={agency?.agencyName ?? ''} showServices2={showServices2} />
      }
      
      {/* Footer Banner Vendi */}
      {showFooterBannerVendi && <FooterBannerVendi />}

    </>
  );
};

export default HomePage;